/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[tmoAnchorDetect]',
})
export class AnchorDetectDirective implements OnInit {
  // TODO Change public to private for link, isNewTab, el
  @Input() public link: string;
  @Input() public isNewTab: boolean;
  @Input() public seoHref: boolean;

  public el: ElementRef;
  constructor(el: ElementRef) {
    this.el = el;
  }
  /**
   * Initializes the screen and controls its graphical element
   * @returns void
   */
  public ngOnInit(): void {
    if (this.link) {
      const externalLinkPrefix: string = 'ext:';
      if (this.link.charAt(0) !== '/' || this.link.startsWith(externalLinkPrefix)) {
        this.el.nativeElement.target = this.isNewTab ? '_blank' : '_self';
        this.el.nativeElement.href = this.link.split(externalLinkPrefix)[1] || this.link;
      } else {
        this.el.nativeElement.href = this.seoHref
          ? `${window.location.protocol}//${window.location.host}${this.link}`
          : `#${this.link}`;
      }
    }
  }
}
